import { DateTimeUnit, Duration, DurationLike } from "luxon";
import { _throw, IllegalArgumentError } from "shared-ts-utils-core";

export class DurationWheel {
  private readonly start: Duration;
  private readonly timeUnit: DurationLike;

  constructor(args: {
    start: Duration;
    timeUnit?: DateTimeUnit;
    duration?: DurationLike;
  }) {
    this.start = args.start;

    this.timeUnit =
      args.timeUnit != null
        ? { [args.timeUnit]: 1 }
        : args.duration ??
          _throw(
            new IllegalArgumentError(
              "Either timeUnit or duration must be specified"
            )
          );
  }

  run<T>(count: number, fn: (duration: Duration<true>) => T): Array<T> {
    let currCount = 0;
    let currDuration = this.start;
    const result: Array<T> = [];

    do {
      result.push(fn(currDuration));
      currDuration = currDuration.plus(this.timeUnit);
      currCount++;
    } while (currCount <= count);

    return result;
  }

  runUntilDuration<T>(
    untilDuration: Duration,
    fn: (duration: Duration<true>) => T
  ): Array<T> {
    let currDuration = this.start;
    const result: Array<T> = [];

    do {
      result.push(fn(currDuration));
      currDuration = currDuration.plus(this.timeUnit);
    } while (currDuration < untilDuration);

    return result;
  }

  runWhile<T>(
    predicate: (dateTime: Duration) => boolean,
    fn: (duration: Duration<true>) => T
  ): Array<T> {
    let currDuration = this.start;
    const result: Array<T> = [];

    do {
      result.push(fn(currDuration));
      currDuration = currDuration.plus(this.timeUnit);
    } while (predicate(currDuration));

    return result;
  }
}
